import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/auth/Login';
import TermsAndConditions from '../pages/auth/TermsAndConditions';
// components
import LoadingScreen from '../components/LoadingScreen';
import VerifyCode from '../pages/auth/VerifyCode';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ resetPasswordPath, registerPath, children }) {
  const { isAuthenticated, isInitialized, isAcceptedTerms, isEmailVerified } = useAuth();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login resetPasswordPath={resetPasswordPath} registerPath={registerPath} />;
  }

  if (!isAcceptedTerms) {
    if (pathname !== requestedLocation) setRequestedLocation(pathname);
    console.log('AuthGuard: isAcceptedTerms=', isAcceptedTerms);
    return <TermsAndConditions pathname={pathname} />;
  }

  if (!isEmailVerified) {
    if (pathname !== requestedLocation) setRequestedLocation(pathname);
    console.log('AuthGuard: isEmailVerified=', isEmailVerified);
    return <VerifyCode />
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }


  return <>{children}</>;
}
